import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import RootScreen from "./RootScreen";
import { MainLayout } from "./MainLayout";

type RootScreenProps = {
  nav: React.ReactNode;
  showModeView?: boolean;
};

export function AdminRootScreen({ nav, showModeView }: RootScreenProps) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const [openNav, setOpenNav] = useState(matches);
  useEffect(() => {
    setOpenNav(!matches);
  }, [matches]);

  return <RootScreen main={<MainLayout showModeView={showModeView} />} nav={nav} />;
}
